import { Controller } from 'react-hook-form'
import { Info } from 'lucide-react'
import { CKEditor4 } from '@/components/editor/CKEditor4'
import companyFormStyles from '../../styles/organizationCard.module.css'
import type { OrganizationEditSectionProps } from '../../types/components'

export function OrganizationHelpAboutTab({ ctx }: OrganizationEditSectionProps) {
  return (
        <div
          id="org-panel-helpabout"
          role="tabpanel"
          aria-labelledby="org-tab-helpabout"
          hidden={ctx.selectedTab !== 'helpabout'}
        >
        <div className="space-y-6">
          <div className={companyFormStyles.card}>
            <div className={companyFormStyles.cardHeader}>
              <Info className={companyFormStyles.cardIcon} />
              <h2 className={companyFormStyles.cardTitle}>
                Applicant Help/About
              </h2>
            </div>
            <div className={companyFormStyles.cardBody}>
              <div className={companyFormStyles.formGroup}>
                <Controller
                  name="about_content_applicant"
                  control={ctx.control}
                  render={({ field: { value, onChange } }) => (
                    <CKEditor4 id="org-about-applicant" value={value || ''} onChange={onChange} />
                  )}
                />
              </div>
            </div>
          </div>

          <div className={companyFormStyles.card}>
            <div className={companyFormStyles.cardHeader}>
              <Info className={companyFormStyles.cardIcon} />
              <h2 className={companyFormStyles.cardTitle}>
                PMC/Property Help/About
              </h2>
            </div>
            <div className={companyFormStyles.cardBody}>
              <div className={companyFormStyles.formGroup}>
                <Controller
                  name="about_content_pmc"
                  control={ctx.control}
                  render={({ field: { value, onChange } }) => (
                    <CKEditor4 id="org-about-pmc" value={value || ''} onChange={onChange} />
                  )}
                />
              </div>
            </div>
          </div>

          <div className={companyFormStyles.card}>
            <div className={companyFormStyles.cardHeader}>
              <Info className={companyFormStyles.cardIcon} />
              <h2 className={companyFormStyles.cardTitle}>
                Liberty Rent Staff Help/About
              </h2>
            </div>
            <div className={companyFormStyles.cardBody}>
              <div className={companyFormStyles.formGroup}>
                <Controller
                  name="about_content"
                  control={ctx.control}
                  render={({ field: { value, onChange } }) => (
                    <CKEditor4 id="org-about-staff" value={value || ''} onChange={onChange} />
                  )}
                />
              </div>
            </div>
          </div>
        </div>
        </div>

  )
}
